import {
  ADMIN,
  LEARNING_MANAGER,
  LOCAL_SUPER_USER,
  MANAGER,
  SUPER_ADMIN,
  SUPER_USER,
  TESTER,
} from '../helpers/constants'

// TODO: These rules should be phased out and replaced with Permission System:

export function FeatureFlagPlugin(Vue) {
  const featuresEnabled = {
    // this featureflag does nothing, but can be enabled in backend
    // so it must exist here to avoid an error
    adminview_onboarding: {
      enabled: false,
      roles: [
        TESTER,
        SUPER_ADMIN,
        ADMIN,
        SUPER_USER,
        LOCAL_SUPER_USER,
        MANAGER,
      ],
    },
    enable_reports_dashboard: {
      enabled: false,
      roles: [
        TESTER,
        SUPER_ADMIN,
        ADMIN,
        SUPER_USER,
        LOCAL_SUPER_USER,
        MANAGER,
      ],
    },
    enable_scorm_support: {
      enabled: false,
      roles: [
        TESTER,
        SUPER_ADMIN,
        ADMIN,
        SUPER_USER,
        LOCAL_SUPER_USER,
        MANAGER,
      ],
    },
    enable_irl_events: {
      enabled: false,
      roles: [
        TESTER,
        SUPER_ADMIN,
        ADMIN,
        SUPER_USER,
        LOCAL_SUPER_USER,
        MANAGER,
      ],
    },
    enable_reset_playtime: {
      enabled: false,
      roles: [
        TESTER,
        SUPER_ADMIN,
        ADMIN,
        SUPER_USER,
        LOCAL_SUPER_USER,
        LEARNING_MANAGER,
      ],
    },
    expose_creator_token: {
      enabled: false,
      roles: [
        TESTER,
        SUPER_ADMIN,
        ADMIN,
        SUPER_USER,
        LOCAL_SUPER_USER,
        MANAGER,
      ],
    },
  }

  const checkEnabled = (featureEnabled, userRoles) => {
    return featureEnabled || userRoles.includes(SUPER_ADMIN)
  }

  const checkRoles = (featureRoles, userRoles) => {
    return userRoles.some((role) => featureRoles.includes(role))
  }

  Vue.prototype.$featureFlag = {
    setEnabled(featuresArray) {
      // beware : feature flags that can be set in backend will appear in 'featuresArray'
      // feature flag must be added here to be referenced by $featureFlag.isEnabled
      featuresArray.forEach((feature) => {
        if (Object.keys(featuresEnabled).includes(feature)) {
          featuresEnabled[feature].enabled = true
        }
      })
    },
    isEnabled(feature, userRoles) {
      const featureConfig = featuresEnabled[feature]
      if (featureConfig) {
        const isEnabled = checkEnabled(featureConfig.enabled, userRoles)
        const canAccess = checkRoles(featureConfig.roles, userRoles)
        return isEnabled && canAccess
      } else {
        // biome-ignore lint/suspicious/noConsole: dev-only signal; Sentry is prod-build-only (sentryPlugin.js) so this would go silent where it matters
        console.warn(
          `Unable to find featureflag configuration for flag ${feature}`
        )
        return false
      }
    },
  }
}
